export type Theme = "light" | "dark" | "system"

const STORAGE_KEY = "theme"

function isBrowser() {
  return typeof window !== "undefined"
}

export function getStoredTheme(): Theme {
  if (!isBrowser()) return "system"

  const stored = window.localStorage.getItem(STORAGE_KEY)
  if (stored === "light" || stored === "dark" || stored === "system") {
    return stored
  }

  return "system"
}

export function resolveTheme(theme: Theme): Exclude<Theme, "system"> {
  if (!isBrowser()) return "light"
  if (theme !== "system") return theme

  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
}

export function applyTheme(theme: Theme) {
  if (!isBrowser()) return

  const root = window.document.documentElement
  const resolvedTheme = resolveTheme(theme)

  root.classList.remove("light", "dark")
  root.classList.add(resolvedTheme)
  root.dataset.theme = theme
  root.dataset.resolvedTheme = resolvedTheme
}

export function persistTheme(theme: Theme) {
  if (!isBrowser()) return
  window.localStorage.setItem(STORAGE_KEY, theme)
}

export function initializeTheme(theme: Theme = getStoredTheme()) {
  applyTheme(theme)
  return theme
}
